import {_import_} from './_import.js';
const url = 'consultant'; // 模块文件夹路径
const consultant = _import_(url + '/index');

export default [
  {
    path: '/consultant',
    name: 'consultant',
    meta: {
      title: {
        title: '添加专属健康顾问',
        color: '#ffffff'
      },
      needLogin: false
    },
    component: consultant
  }
];



// WEBPACK FOOTER //
// ./src/router/consultant.js